import styled from "styled-components"
import { Link as LinkRouter } from "react-router-dom"

export const Nav = styled.nav`
    background: #000000db;
    height: 80px;
    // margin-top: -80px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 10;

    @media screen and (min-width: 1440px){
        margin: auto;
        width: 1440px;
    }

    @media screen and (max-width: 960px){
        transition: 0.8s all ease;
    }
`;

export const NavbarContainer = styled.div`
    display: flex;
    justify-content: space-between;
    height: 80px;
    z-index: 1;
    width: 100%;
    margin: 0 100px;
    align-items: center;

    @media screen and (min-width: 1440px){
        margin: auto;
    }

    @media screen and (max-width: 768px){
        padding: 0 24px;
        margin: 0;
    }
`;

export const NavLogo = styled(LinkRouter)`
    color: var(--white);
    display: flex;
    align-items: center;
    justify-self: flex-start;
    cursor: pointer;
    text-decoration: none;
`;

export const MobileIcon = styled.div`
    // display: none

    // @media screen and (max-width: 768px){
    //     display: block;
    //     position: absolute;
    //     top: 0;
    //     right: 0;
    //     transform: translate(-100%, 60%);
    //     width: 24px;
    //     height: 24px;
    //     cursor: pointer;
    // }
`;

export const NavMenu = styled.ul`
    display: flex;
    align-items: flex-end;
    list-style: none;
    text-align: center;
    // margin-right: -22px;

    @media screen and (max-width: 768px){
        display: none;
    }
`;

export const NavItem = styled.li`
    padding-right: 75px;
    line-height: 23px;
`;

export const LastNavItem = styled(NavItem)`
    padding-right: 0;
`

export const NavLinks = styled(LinkRouter)`
    color: var(--white);
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-decoration: none;
    height: 100%;
    cursor: pointer;
`;

export const ColorNavLinks = styled(NavLinks)`
    //  background: -webkit-linear-gradient(128.12deg, #F72B89 1.03%, #13B7D5 53.11%, #FFE200 100.04%),
    // -webkit-linear-gradient(0deg, #FFFFFF, #FFFFFF);  
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;  
`;